<template>
  <!-- same format with positions.vue -->
  <div>
    <v-btn @click="dialog = true"
      ><v-icon class="mr-2" color="yellow">mdi-hand-coin</v-icon> Employee
      Benefits</v-btn
    >
    <v-dialog v-model="dialog" max-width="800px" persistent>
      <v-card>
        <ModalHeader
          title="Employee Benefits"
          icon="mdi-account"
          @close="dialog = false"
        />
        <!-- add benefit card -->
        <v-card-text class="pa-4">
          <v-select
            label="Employee"
            dense
            outlined
            item-text="name"
            item-value="id"
            :items="employees"
            v-model="employee_benefit.employee_id"
          ></v-select>
          <v-select
            label="Benefit"
            dense
            outlined
            item-text="name"
            item-value="id"
            :items="benefits"
            v-model="employee_benefit.benefit_id"
          ></v-select>
          <v-text-field
            label="Account Number"
            dense
            outlined
            v-model="employee_benefit.account_number"
          ></v-text-field>
          <!-- date issued -->
          <div class="d-flex">
            <p class="mr-2">Date Issued</p>
            <input
              type="date"
              v-model="employee_benefit.date_issued"
              class="mt-n3"
            />
          </div>

          <v-btn color="primary" @click="submit" :loading="loading"
            >Submit</v-btn
          >

          <v-text-field
            label="Search"
            v-model="search"
            prepend-icon="mdi-magnify "
          ></v-text-field>
          <!-- benefits data table here -->
          <v-data-table :items="employee_benefits" :headers="headers" dense>
            <template v-slot:item.actions="{ item }">
              <div class="d-flex">
                <!-- edit -->

                <v-btn icon color="warning" @click="editEmployeeBenefit(item)"
                  ><v-icon>mdi-pencil</v-icon></v-btn
                >
                <v-btn icon color="red" @click="del(item)"
                  ><v-icon>mdi-delete</v-icon></v-btn
                >
              </div>
            </template>
          </v-data-table></v-card-text
        >
        <v-card-actions>
          <v-btn @click="dialog = false">Close</v-btn>
        </v-card-actions>
      </v-card></v-dialog
    >
    <!-- lazy loaded components-->
    <edit-employee-benefits-modal
      v-if="editDialog"
      :item="editItem"
      @close="editDialog = false"
    ></edit-employee-benefits-modal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  components: {
    EditEmployeeBenefitsModal: () => import("./editEmployeeBenefitsModal.vue"),
  },
  data() {
    return {
      editDialog: false,
      editItem: {},

      dialog: false,
      search: "",
      loading: false,
      employee_benefit: {
        employee_id: null,
        benefit_id: null,
      },
      headers: [
        { text: "Actions", value: "actions", sortable: false },
        { text: "ID", value: "id" },
        { text: "Employee Name", value: "employee.name" },
        { text: "Benefit Name", value: "benefit.name" },
        { text: "Account Number", value: "account_number" },
        { text: "Date Issued", value: "date_issued" },
      ],
    };
  },
  computed: {
    ...mapGetters({
      employees: "employee/employees",
      benefits: "benefit/benefits",
      employee_benefits: "employee_benefit/employee_benefits",
    }),
  },
  methods: {
    ...mapActions({
      add_employee_benefit: "employee_benefit/add_employee_benefit",
      delete_employee_benefit: "employee_benefit/delete_employee_benefit",
      get_employee_benefits: "employee_benefit/get_employee_benefits",
    }),
    editEmployeeBenefit(item) {
      this.editItem = item;
      this.editDialog = true;
    },
    async submit() {
      this.loading = true;
      try {
        this.add_employee_benefit(this.employee_benefit);
        this.$alert({
          title: "Success",
          message: "Employee benefit added successfully",
          color: "success",
          icon: "mdi-check-circle",
        });
      } catch (error) {
        console.error("Error adding employee benefit:", error);
      } finally {
        this.loading = false;
      }
    },
    async del(item) {
      if (
        await this.$confirm({
          title: "Delete Employee Benefit",
          message: "Are you sure you want to delete this employee benefit?",
          color: "red",
          icon: "mdi-delete",
        })
      ) {
        try {
          this.delete_employee_benefit(item);
        } catch (error) {
          console.error("Error deleting employee benefit:", error);
        }
      }
    },
  },
  created() {
    this.get_employee_benefits();
    console.log("employee benefits", this.employee_benefits);
  },
};
</script>
